import { MenuItem, Select } from "@material-ui/core";
import { ApartmentRole } from "../../../../graphql/models";

export type RolePickerProps = {
  canAddAdmin: boolean;
  role: ApartmentRole;
  onRoleChange: (newRole: ApartmentRole) => void;
};

export default function ApartmentRolePicker(props: RolePickerProps) {
  const { canAddAdmin, onRoleChange, role } = props;

  return (
    <Select
      value={role}
      onChange={(v) => onRoleChange(v.target.value as ApartmentRole)}
    >
      <MenuItem value={ApartmentRole.Guest}>Guest (ospite)</MenuItem>
      <MenuItem disabled={!canAddAdmin} value={ApartmentRole.Admin}>
        Admin
      </MenuItem>
    </Select>
  );
}
